import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../../lib/api/axios-instance';

export interface CreateSignupCheckoutInput {
  email: string;
  nom: string;
  prenom: string;
  password: string;
  tierId: string;
  planType: 'BASIC' | 'ADVANCED';
  promoCode?: string;
  /** E.164 (e.g. +33612345678). Sent as `phone_number` to the API. */
  phoneNumber?: string;
}

export interface CreateSignupCheckoutResponse {
  data: {
    checkoutUrl: string;
    sessionId: string;
  };
  message: string;
}

export function useCreateSignupCheckout() {
  return useMutation({
    mutationFn: async (input: CreateSignupCheckoutInput) => {
      const { phoneNumber, ...rest } = input;
      const body = {
        ...rest,
        ...(phoneNumber?.trim() ? { phone_number: phoneNumber.trim() } : {}),
      };
      const response = await axiosInstance.post<CreateSignupCheckoutResponse>(
        '/payments/create-signup-checkout',
        body
      );
      return response.data;
    },
    onError: (error: any) => {
      console.error('Signup checkout error:', error);
      throw error;
    }
  });
}
